/* eslint-disable no-param-reassign,no-shadow,prefer-const */
import { Store } from '@wonderlandlabs/looking-glass-engine';
import React from 'react';
import _ from 'lodash';
import { message } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
import { Category, categoryFetchQuery, categoryAddRecord, categoryFetchRecord } from '../../../store/models/Category';

import { eventToType, eventToString }
  from '../../../utils/eventExtraction';

const NameTest = /(.+) ([\d]+)$/;

export default ({
  query, name, isCategory = false, token,
}) => {
  const quatStore = new Store({
    state: {},
    actions: {
      async makeUnique({ state, actions }) {
        let { name, token } = state;

        let prefix = name;
        let number = 0;
        if (NameTest.test(name)) {
          let m = NameTest.exec(name);
          prefix = m[1];
          number = parseInt(m[2], 10);
        }
        let saved = false;
        do {
          try {
            saved = await categoryFetchRecord(name, token);
          } catch (err) {
            saved = false;
          }
          if (saved) {
            number += 1;
            name = `${prefix} ${number}`;
          }
        } while (saved);
        actions.chooseName(name);
      },
      chooseStep({ actions }, step) {
        actions.setStep(step);
        if (step === 1) {
          actions.revertMetadata();
        }
      },
      async revertMetadata(store) {
        if (!store.state.name) return;
        await store.actions.checkName();
        const { name, savedUnderName } = store.state;
        const { state } = store;
        if (savedUnderName) {
          console.log('revertMetadata: reverting to ', savedUnderName);
          const update = {
            name: savedUnderName.categoryName,
            tags: savedUnderName.tagsToText(),
            description: savedUnderName.categoryDescription,
            notes: savedUnderName.notes,
            version: savedUnderName.version,
          };
          console.log('revert media: updating with ', update, ' for ', name);
          return { ...state, ...update };
        }
        console.log('revert media: no save under name for ', name);

        return { ...state };
      },
      chooseDescription({ actions }, event) {
        actions.setDescription(eventToString(event));
      },
      chooseVersion({ actions }, event) {
        actions.setVersion(eventToString(event));
      },
      chooseNotes({ actions }, event) {
        actions.setNotes(eventToString(event));
      },
      chooseTags({ actions }, event) {
        actions.setTags(eventToString(event));
      },
      rechooseType({ actions }) {
        actions.setStep(0);
      },
      async chooseName({ actions }, event) {
        const n = eventToString(event);
        actions.setName(n);
        await actions.revertMetadata();
        actions.checkName(n);
      },
      asCategory({ actions }) {
        actions.setIsCategory(true);
        actions.setStep(1);
      },
      asQuery({ actions }) {
        actions.setIsCategory(false);
        actions.setStep(1);
      },
      async checkName({ actions, state }, check = null) {
        let { name, token } = state;
        if (check) {
          name = check;
        }
        try {
          let saved = await categoryFetchRecord(name, token);
          if (saved) saved = new Category(saved);
          actions.setSavedUnderName(saved);
        } catch (err) {
          actions.setSavedUnderName(false);
        }
      },
      // eslint-disable-next-line no-shadow
      async update(store, { name, query }) {
        const { actions } = store;
        if (name !== store.state.name) {
          await actions.chooseName(name);
        }
        return {
          ...store.state, query, step: 0,
        };
      },
      // dont use this
      async reset({ state, actions }) {
        await actions.chooseName(name);
        actions.setQuery(query);
        actions.setIsCategory(!!isCategory);
        actions.setStep(0);
      },
    },
  });

  quatStore
    .addProp('query', {
      start: query,
    })
    .addProp('step', {
      type: 'integer',
      start: 0,
    })
    .addProp('version', {
      start: '1.0.0',
      type: 'string',
    })
    .addProp('description', {
      start: '',
      type: 'string',
    })
    .addProp('tags', {
      start: '',
      type: 'string',
    })
    .addProp('notes', {
      start: '',
      type: 'string',
    })
    .addProp('savedUnderName', {
      start: false,
    })
    .addProp('name', {
      type: 'string',
      start: name,
    })
    .addProp('token', {
      type: 'string',
      start: token,
    })
    .addProp('override', {
      start: false,
    })
    .addProp('isCategory', {
      type: 'boolean',
      start: !!isCategory,
    });

  quatStore.debugStream = {
    next(data) {
      return;
      console.log(
        '--debug queryTabStore for pfdStore ', data.state.queryName, ': change: ',
        _.get(data, 'change.info.action'),
        'resolved', _.get(data, 'change._resolved'),
        'id', _.get(data, 'change.id'),
        'data:', data,
      );
    },
  };
  quatStore.start();
  quatStore.actions.reset();

  return quatStore;
};
